import React, { useEffect, useMemo, useRef, useState } from "react";
import {
  ArrowIcon,
  BackArrowIcon,
  RadioBoxActiveIcon,
  RadioBoxInActiveIcon
} from "../../Assets/assets";
import { isValidArray } from "../../Services/validators";
import Button from "../Button/Button";
import "./Filters.css";

export default function SingleSelect(props) {
  const dropdownRef = useRef(null);
  const [show, setShow] = useState(false);
  const [showCustomDropDown, setShowCustomDropDown] = useState(false);

  const getFilterSelected = () => {
    if (!props.selected?.length) {
      return "All";
    }

    if (props.selected.length === 1) {
      return props.selected;
    }
    const firstSelected = isValidArray(props.selected)
      ? props.selected[0]
      : props.selected;

    return `${firstSelected}`;
  };

  const handleSelect = (data) => {
    if (typeof data === "string" && data.toLowerCase()?.includes("select")) {
      setShow(false);
      return setShowCustomDropDown(true);
    }

    if (props.array) {
      props.setSelectedFilters({
        ...props.selectedFilters,
        [props.data.key]: [data]
      });
    } else {
      if (props.selectedFilters?.[props.data.key] === data) {
        props.setSelectedFilters({
          ...props.selectedFilters,
          [props.data.key]: "All"
        });
      } else {
        props.setSelectedFilters({
          ...props.selectedFilters,
          [props.data.key]: data
        });
      }
    }
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShow(false);
        setShowCustomDropDown(false);
      }
    };

    const handleEscKey = (event) => {
      if (event.key === "Escape") {
        setShow(false);
        setShowCustomDropDown(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    document.addEventListener("keydown", handleEscKey);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("keydown", handleEscKey);
    };
    // eslint-disable-next-line
  }, []);

  const isFilterApplied = useMemo(() => {
    const applied = props.appliedFilters?.[props.data.key];
    if (isValidArray(applied) || applied?.length > 0) {
      return true;
    } else {
      return false;
    }
    // eslint-disable-next-line
  }, [props.appliedFilters]);

  const isSelectedNotApplied = useMemo(() => {
    if (
      props.selectedFilters?.[props.data.key]?.length ===
      props.appliedFilters?.[props.data.key]?.length
    ) {
      return false;
    } else {
      return true;
    }
  }, [props.selectedFilters, props.appliedFilters, props.data.key]);
  return (
    <div
      data-cy={`${props?.["data-cy"]}-SELECT-FILTER`}
      ref={dropdownRef}
      className={`${props.disabled ? "cursor-no-drop" : "cursor-pointer"}`}
    >
      <div
        onClick={() => {
          if (!props.disabled) {
            setShow(!show);
            setShowCustomDropDown(false);
          }
        }}
        style={{
          ...(show || isFilterApplied || showCustomDropDown
            ? {
                backgroundColor: "var(--tertiaryColor8)",
                border: "solid 1px var(--tertiaryColor5)"
              }
            : { border: "solid 1px transparent" }),
          ...(!show && isSelectedNotApplied
            ? { border: "solid 1px var(--tertiaryColor5)" }
            : {})
        }}
        className={`display-flex flex-align-items-center padding-default position-relative`}
      >
        {!show && isSelectedNotApplied && (
          <div
            style={{
              top: "-2px",
              right: "-2px",
              borderRadius: "50%",
              width: "7px",
              height: "7px",
              backgroundColor: "#1c1c1c",
              zIndex: 100
            }}
            className="position-absolute flex-justify-content-center flex-align-items-center"
          >
            <div
              style={{
                backgroundColor: "var(--secondaryColor)",
                width: "6px",
                height: "6px",
                borderRadius: "50%"
              }}
            />
          </div>
        )}

        <div className="font-color-tertiaryColor6 font-size-small white-space-nowrap">
          {props.data.title}
        </div>
        <div className="font-size-medium font-color-tertiaryColor padding-left-small white-space-nowrap padding-right-small">
          {getFilterSelected()}
        </div>
        <div
          style={{
            height: "16px",
            width: "16px"
          }}
        >
          <ArrowIcon color="var(--tertiaryColor6)" />
        </div>
      </div>

      {show && props.data.options && !showCustomDropDown && (
        <div
          style={{
            height: "210px",
            width: "250px",
            top: "48px",
            zIndex: 200
          }}
          className="position-absolute padding-large box-shadow-default background-color-tertiaryColor2 font-color-tertiaryColor"
        >
          <div
            style={{ height: "calc(100% - 48px)" }}
            className="overflow-scroll inherit-parent-height inherit-parent-width"
          >
            {props.data.options?.map((data, i) => (
              <div
                data-cy={`${data?.toString().toUpperCase()}-${
                  props?.["data-cy"]
                }-SELECT-FILTER-OPTION`}
                key={i}
                className={`display-flex ${
                  i === 0 ? "" : "padding-top-default"
                } flex-align-items-center`}
                onClick={() => {
                  handleSelect(data);
                }}
              >
                <div
                  style={{
                    height: "16px",
                    width: "16px"
                  }}
                  className="margin-right-default display-flex flex-align-items-center"
                >
                  {props.selectedFilters?.[props.data.key]?.includes(data) ? (
                    typeof data === "string" &&
                    props.appliedFilters?.[props.data.key]?.includes(data) ? (
                      <RadioBoxActiveIcon color="var(--secondaryColor)" />
                    ) : (
                      <RadioBoxActiveIcon color="var(--secondaryColor)" />
                    )
                  ) : (
                    <RadioBoxInActiveIcon />
                  )}
                </div>
                {data
                  ?.toString()
                  ?.toLowerCase()
                  ?.includes("select") ? (
                  <div className="display-flex inherit-parent-width flex-justify-content-space-between flex-align-items-center">
                    <div className="padding-right-default white-space-nowrap">
                      {data}
                    </div>
                    <div
                      style={{
                        height: "16px",
                        width: "16px",
                        transform: "rotate(-90deg)"
                      }}
                    >
                      <ArrowIcon color="var(--tertiaryColor6)" />
                    </div>
                  </div>
                ) : (
                  <div className="white-space-nowrap text-transform-capitalize">
                    {data}
                  </div>
                )}
              </div>
            ))}
          </div>
          {props.onResetClick ? (
            <div
              className={`display-flex margin-top-large ${
                props.data.options.length < 6 ? "" : "margin-bottom-large"
              } flex-justify-content-space-between`}
            >
              <div className="inherit-parent-width">
                <Button
                  data-cy={`${props?.["data-cy"]}-SELECT-RESET-BUTTON`}
                  variant="danger"
                  text="Reset"
                  boxShadow={false}
                  className="inherit-parent-width padding-left-large padding-right-large"
                  onClick={() => {
                    props.onResetClick(props.data.key);
                  }}
                />
              </div>
            </div>
          ) : (
            <></>
          )}
        </div>
      )}

      {!show && showCustomDropDown && (
        <div
          style={{
            height: "210px",
            width: "250px",
            top: "48px",
            zIndex: 200
          }}
          className="position-absolute display-flex flex-direction-column flex-justify-content-space-between padding-large box-shadow-default background-color-tertiaryColor2 font-color-tertiaryColor"
        >
          <CustomSelectEmployee
            setShowCustomDropDown={setShowCustomDropDown}
            showCustomDropDown={showCustomDropDown}
            data={props.data}
            setSelectedFilters={props.setSelectedFilters}
            selectedFilters={props.selectedFilters}
          />

          <div
            className={`display-flex margin-top-larger ${
              props.data.options.length < 6 ? "" : "margin-bottom-large"
            } flex-justify-content-space-between`}
          >
            <div className="inherit-parent-width">
              <Button
                data-cy={`${props?.["data-cy"]}-SELECT-RESET-BUTTON`}
                variant="danger"
                text="Reset"
                boxShadow={false}
                className="inherit-parent-width padding-left-large padding-right-large"
                onClick={() => {
                  props.onResetClick(props.data.key);
                }}
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

const CustomSelectEmployee = (props) => {
  const [isFocused, setIsFocused] = useState(false);

  return (
    <>
      <div className="display-flex">
        <div
          onClick={() => {
            props.setShowCustomDropDown(false);
          }}
          style={{
            width: "16px",
            height: "16px"
          }}
        >
          <BackArrowIcon color="var(--tertiaryColor6)" />
        </div>
        <div className="padding-left-default font-size-medium font-color-tertiaryColor6">
          CUSTOM EMPLOYEE
        </div>
      </div>

      <div
        style={{
          borderBottom: `solid 1px ${
            isFocused ? "var(--tertiaryColor)" : "var(--tertiaryColor4)"
          }`
        }}
        onFocus={() => {
          setIsFocused(true);
        }}
        onBlur={() => {
          setIsFocused(false);
        }}
      >
        <div
          onFocus={() => {
            setIsFocused(true);
          }}
          onBlur={() => {
            setIsFocused(false);
          }}
          className="padding-top-large font-size-smaller"
        >
          CONTACT
        </div>
        <input
          style={{
            width: "100%",
            border: "none",
            backgroundColor: "transparent",
            paddingBottom: "10px"
          }}
          type="text"
          data-cy="CONTACT-INPUT-FILED"
          placeholder="ENTER EMAIL / PHONE NUMBER"
          value={props.selectedFilters?.[props.data.key] || ""}
          onFocus={() => {
            setIsFocused(true);
          }}
          onBlur={() => {
            setIsFocused(false);
          }}
          onChange={(e) => {
            props.setSelectedFilters({
              ...props.selectedFilters,
              [props.data.key]: e.target.value
            });
          }}
        />
      </div>
    </>
  );
};
